import { PlanterMiniGame } from "./PlanterMiniGame";

// Register the web component
customElements.define("planter-mini-game", PlanterMiniGame);

export { PlanterMiniGame };
